import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=0b8e01ce&scoped=true"
import script from "./customPage.vue?vue&type=script&lang=js"
export * from "./customPage.vue?vue&type=script&lang=js"
import style0 from "./customPage.vue?vue&type=style&index=0&id=0b8e01ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e01ce",
  null
  
)

export default component.exports